import { useCallback, useState } from 'react';
import { useDebouncedEffect } from '../../../../Helpers/CustomHooks';
import { ServiceClient } from '../../../../Services/ServiceClient';

export const useCustomerSearch = (query, setIsOpen, setIsLoading) => {
  const [customers, setCustomers] = useState([]);

  const findCustomers = useCallback(() => {
    if (query?.length === 0) {
      if (customers.length !== 0) {
        setCustomers([]);
      }
      return;
    }

    setIsLoading(true);

    ServiceClient.findCustomers(
      query,
      result => {
        if (result.length > 0) {
          setIsLoading(false);
          setCustomers(mapCustomerSearchResult(result));
          setIsOpen(true);
        } else {
          setIsLoading(false);
          setCustomers([]);
        }
      },
      () => {
        setIsLoading(false);
        setCustomers([]);
        setIsOpen(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useDebouncedEffect(findCustomers, 500);

  return customers;
};

const mapCustomerSearchResult = customers => {
  return customers.map(customer => {
    return {
      customerNumber: customer.number,
      customerName: customer.name,
      legalNumber: customer.legalNumber,
    };
  });
};
